"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProductsApi = require("./ProductsApi");
Object.keys(_ProductsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ProductsApi[key];
    }
  });
});